import { c as _c } from "react/compiler-runtime";
import './help-me-choose-answers.scss';
import { parseAsString, useQueryState } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionCardsGroup } from '../../../molecules/selection-cards-group/selection-cards-group.tsx';
import disabilityImage from '../images/disability-help-me-choose.webp';
import greatestNeedImage from '../images/greatest-need-help-me-choose.webp';
import hivAidsImage from '../images/hiv-help-me-choose.webp';
import vulnerableImage from '../images/vulnerable-help-me-choose.webp';
import { createAnswers } from '../utils/answers.ts';
export const HelpMeChooseCause: React.FC = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["help-me"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const [causes, setCauses] = useQueryState("filters", parseAsString);
  let t1;
  if ($[1] !== causes) {
    t1 = causes ? [causes] : [];
    $[1] = causes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [controlledCauses, setControlledCauses] = useState(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    const causeCategories = [{
      label: "hiv",
      value: "affectedHiv",
      imageUrl: hivAidsImage
    }, {
      label: "exploitation",
      value: "vulnerableExploitation",
      imageUrl: vulnerableImage
    }, {
      label: "disability",
      value: "hasDisabilities",
      imageUrl: disabilityImage
    }, {
      label: "anywhere",
      value: "anywhere",
      imageUrl: greatestNeedImage
    }];
    t2 = createAnswers("how", causeCategories);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const causeAnswers = t2;
  let t3;
  if ($[4] !== setCauses) {
    t3 = nextValues => {
      const value = nextValues && nextValues.length > 0 ? nextValues[0] : null;
      const isChecked = !!value;
      setCauses(isChecked ? value : null);
      setControlledCauses(isChecked ? [value] : []);
    };
    $[4] = setCauses;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSelectionChange = t3;
  let t4;
  if ($[6] !== controlledCauses) {
    t4 = controlledCauses || [];
    $[6] = controlledCauses;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("howAnswers.groupLabel");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleSelectionChange || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center"><SelectionCardsGroup cards={causeAnswers} selectionMode="single" value={t4} label={t5} onChange={handleSelectionChange} /></div>;
    $[10] = handleSelectionChange;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};